<section class="section_panel">
  <app-skeleton-toolbar></app-skeleton-toolbar>
  <app-skeleton-checkbox-vehicle></app-skeleton-checkbox-vehicle>
  <app-divider-vehicle style="opacity: 0"></app-divider-vehicle>
  <div class="main_content">
    <div class="skeleton_container">
      <app-skeleton-collection-vehicle
        *ngFor="let item of [1, 2, 3]"
      ></app-skeleton-collection-vehicle>
      <div class="skeleton-card-vehicle-container">
        <app-skeleton-card-vehicle
          *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
        ></app-skeleton-card-vehicle>
      </div>
    </div>
  </div>
  <app-divider-vehicle style="opacity: 0"></app-divider-vehicle>
  <div class="button-toggle-container-container">
    <app-skeleton-button-toggle-container></app-skeleton-button-toggle-container>
  </div>
</section>
